(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var cartJsUrl = function () {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      return root + 'cart.js';
    };

    function selected(form) {
      return form.querySelector('input[name="id"]:checked');
    }

    function refresh(form) {
      var button = form.querySelector('[data-lp-card-submit]');
      var label = form.querySelector('[data-lp-card-label]');
      var stock = form.querySelector('[data-lp-card-stock]');
      var error = form.querySelector('[data-lp-card-error]');
      var choice = selected(form);
      if (button.dataset.hasSizes === 'true' && !button.disabled) {
        label.textContent = choice ? 'Ajouter · ' + choice.dataset.label : 'Choisir ma taille';
      }
      if (choice && choice.dataset.stock) {
        stock.textContent = choice.dataset.stock;
        stock.hidden = false;
      } else {
        stock.hidden = true;
      }
      if (choice) error.hidden = true;
      var card = form.closest('[data-lp-card]');
      var added = card && card.querySelector('[data-lp-card-added]');
      if (added) added.hidden = true;
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('.lp-chip__input');
      if (input) refresh(input.form);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('[data-lp-card-form]')) return;
      event.preventDefault();
      var button = form.querySelector('[data-lp-card-submit]');
      var error = form.querySelector('[data-lp-card-error]');
      var hasSizes = button.dataset.hasSizes === 'true';
      if (hasSizes && !selected(form)) {
        error.hidden = false;
        var first = form.querySelector('.lp-chip__input:not(:disabled)');
        if (first) first.focus();
        return;
      }
      error.hidden = true;
      button.disabled = true;
      fetch(form.getAttribute('action') + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data && result.data.description ? result.data.description : '');
          var card = form.closest('[data-lp-card]');
          var added = card.querySelector('[data-lp-card-added]');
          if (added) added.hidden = false;
          return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-lp-cart-count]').forEach(function (node) {
            node.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('lp:cart', { detail: cart }));
        })
        .catch(function (failure) {
          error.textContent = failure.message || error.textContent;
          error.hidden = false;
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
